import { Injector, NgModule } from '@angular/core';

import { LaborProductsSearchControlComponent } from './products.labor-search.control.component';
import { ProductActionsComponent }             from './product.actions.component';
import { ProductBranchStockComponent }         from './product.branch-stock.component';
import { ProductsAdvancedSearchComponent }     from './products.advanced-search.component';
import { ProductSearchService }                from './product.search.service';
import { ProductService }                      from './product.service';
import { SharedModule }                        from '../shared/shared.module';
import { TableModule }                         from '../table/table.module';
import { VendorsModule }                       from '../vendors/vendors.module';

@NgModule({
  declarations: [
    LaborProductsSearchControlComponent,
    ProductBranchStockComponent,
    ProductActionsComponent,
    ProductsAdvancedSearchComponent
  ],
  entryComponents: [
    LaborProductsSearchControlComponent,
    ProductBranchStockComponent,
    ProductActionsComponent,
    ProductsAdvancedSearchComponent
  ],
  exports: [
    LaborProductsSearchControlComponent
  ],
  imports: [
    SharedModule,
    TableModule,
    VendorsModule
  ],
  providers: [
    ProductSearchService,
    ProductService
  ]
})
export class ProductsModule {}
